var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonDemandNonRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4216_5550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8977 22.9563C24.8626 24.523 19.6829 28.3904 19.6829 28.3904C19.6826 28.3904 14.5033 24.5234 14.4676 22.9563C10.0935 23.3555 6.66669 27.0331 6.66669 31.5119C6.66695 35.7909 9.794 36.0001 13.8869 36.0001C14.3331 36.0001 14.7909 35.9976 15.2585 35.9976H24.1057C24.5728 35.9976 25.0298 36.0001 25.4757 36.0001C29.5695 36.0001 32.698 35.7909 32.698 31.5121C32.6982 27.0331 29.2725 23.356 24.8977 22.9566V22.9563Z",
    fill: "#84CC16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1132 14.8239C20.7162 14.9957 20.208 15.0902 19.6825 15.0902C19.157 15.0902 18.6488 14.9957 18.2509 14.8239L15.0851 13.4523L12.7352 12.4349C12.5962 12.9919 12.5215 13.5743 12.5215 14.1739C12.5215 18.1305 15.729 24.0793 19.6842 24.0793C23.6414 24.0793 26.8483 18.13 26.8483 14.1739C26.8483 13.5735 26.7733 12.9901 26.6338 12.4329L24.28 13.452L21.1132 14.8239Z",
    fill: "#84CC16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1291 7.44235L10.774 7.72085L10.7192 8.15333C10.4725 8.19544 10.2844 8.41064 10.2844 8.669C10.2844 8.90151 10.4363 9.10044 10.6469 9.16683L10.2555 14.6475C10.2394 14.8774 10.2852 15.2414 10.3572 15.459L10.675 16.4112C10.7112 16.52 10.7587 16.575 10.8065 16.575C10.8543 16.575 10.9016 16.5202 10.938 16.4112L11.256 15.459C11.3284 15.2412 11.3741 14.8774 11.3578 14.6475L10.9672 9.16683C11.1762 9.09941 11.3297 8.90177 11.3297 8.669C11.3297 8.41091 11.1416 8.1957 10.8931 8.15333L10.8437 7.7503L12.3316 8.39514L13.0609 8.7111V11.5233L15.4687 12.5655L18.6345 13.937C18.9225 14.0615 19.3026 14.1238 19.6818 14.1238C20.0613 14.1238 20.4404 14.0615 20.7289 13.937L23.896 12.5655L26.3041 11.5227L26.3044 8.7111L27.0329 8.39514L29.2351 7.44183C29.811 7.19175 29.811 6.78433 29.2351 6.53476L20.7292 2.85328C20.4414 2.72901 20.0621 2.66675 19.6823 2.66675C19.3031 2.66675 18.9231 2.72901 18.635 2.85379L10.129 6.53527C9.55318 6.78484 9.55318 7.192 10.129 7.44235H10.1291Z",
    fill: "#84CC16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4216_5550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonDemandNonRole);
export default __webpack_public_path__ + "static/media/NonDemandNonRole.f50ab6b034f217e42c14c2060331dfc1.svg";
export { ForwardRef as ReactComponent };